module.exports = __webpack_public_path__ + "img/arrow_step_in_right.5042ca88.svg";